
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalog10 as ObiTwowayAnalog10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-10.js';
 
 
 

 
 export const ObiTwowayAnalog10 = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-10',
   elementClass: ObiTwowayAnalog10Element,
   events: {
     
   }
  });
 
 